import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Menu, Button, Dropdown, Tooltip, Cascader, message } from 'antd';
import {
  LoadingOutlined,
  UploadOutlined,
  CheckOutlined,
  BlockOutlined,
  BgColorsOutlined,
  FontSizeOutlined,
  RocketOutlined,
  LineChartOutlined,
  StarOutlined,
  SettingOutlined,
  ArrowLeftOutlined,
  CaretDownOutlined,
  DownOutlined,
} from '@ant-design/icons';

// const { SubMenu } = Menu;
const MenuItem = Menu.Item;

export default class EditorHeader extends React.Component {

  static propTypes = {
    page: PropTypes.shape({
      pages: PropTypes.array.isRequired,
      status: PropTypes.string,
    }).isRequired,
    currentKey: PropTypes.string,
    changeKey: PropTypes.func.isRequired,
    goPagesHome: PropTypes.func.isRequired,
    goToVariant: PropTypes.func.isRequired,
    onPublish: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isPublishing: PropTypes.bool.isRequired,
    busySyncing: PropTypes.bool.isRequired,
    changesNotPublished: PropTypes.bool.isRequired,
    variant: PropTypes.object.isRequired,
    variantUrlsafe: PropTypes.string.isRequired,
  };

  componentDidUpdate(prevProps) {
    if ('variant' in prevProps && 'variant' in this.props) {
      const {variant: prevVariant} = prevProps;
      const { variant } = this.props;
      if(variant && prevVariant && 'status' in prevVariant && 'status' in variant) {
        const prevStatus = prevVariant.status;
        const status = variant.status;
        if (prevStatus === "publishing" && status === "published") {
          message.success({ content: 'Your page has been successfully published', duration: 1.5, key: 'PUBLISH_MESSAGE_KEY' });
        }
      }
    }
  }

  menuClickHandler = ({ key }) => {
    if (key !== this.props.currentKey) {
      this.props.changeKey(key);
    }
  };

  publishClicked = () => {
    const {isLoading, isPublishing, changesNotPublished } = this.props;
    if (isLoading || isPublishing || (!changesNotPublished)) {
      return;
    }
    message.loading({ content: 'Publishing...', duration: 0, key: 'PUBLISH_MESSAGE_KEY' });
    this.props.onPublish();
  };

  renderPublishNode = () => {
    const {isLoading, isPublishing, changesNotPublished, busySyncing } = this.props;

    let inner = null;
    if (isLoading) {
      inner = null
    }
    else {
      if (isPublishing) {
        inner = (
          <React.Fragment>
            <LoadingOutlined className="text-light mr-2" />
            <div className="text-light small">Publishing</div>
          </React.Fragment>
        );
      }
      else {
        if (changesNotPublished) {
          if (busySyncing) {
            inner = (
              <React.Fragment>
                <LoadingOutlined className="text-white mr-2" />
                <div className="text-light small">Auto-saving</div>
              </React.Fragment>
            );
          }
          else {
            inner = (
              <React.Fragment>
                <UploadOutlined className="text-white mr-2" />
                <div className="text-light small">Publish</div>
              </React.Fragment>
            );
          }
        }
        else {
          inner = (
            <React.Fragment>
              <CheckOutlined className="text-light mr-2" />
              <div className="text-light small">Published</div>
            </React.Fragment>
          );
        }
      }
    }

    return (
      <div
        className={cx("publish_area d-flex flex-row align-items-center justify-content-center", {
          loading: isLoading,
          publishing: isPublishing,
          nochanges: !changesNotPublished,
        })}
        onClick={this.publishClicked}
      >
        { inner }
      </div>
    )
  };

  render() {
    const { variant } = this.props;

    const narrowMenu = (
      <Menu
        theme="dark"
        className="editorOverflowHeaderMenu"
        onClick={this.menuClickHandler}
        selectedKeys={[this.props.currentKey]}
      >
        <MenuItem key="block">
          <BlockOutlined />Arrange Blocks
        </MenuItem>
        <MenuItem key="style:color">
          <BgColorsOutlined />Pick Colors
        </MenuItem>
        <MenuItem key="style:font">
          <FontSizeOutlined />Choose Fonts
        </MenuItem>
        <Menu.Divider />
        <MenuItem key="meta:seo">
          <RocketOutlined />SEO
        </MenuItem>
        <MenuItem key="meta:analytics">
          <LineChartOutlined />Analytics
        </MenuItem>
      </Menu>
    );

    const wideMenu = (
      <Menu
        theme="dark" mode="horizontal" className="editor_wide_menu"
        onClick={this.menuClickHandler} selectedKeys={[this.props.currentKey]}
      >
        <MenuItem key="block">
          <BlockOutlined />Blocks
        </MenuItem>

        <Menu.SubMenu className="editorHeaderSubmenu" title={<div className="d-flex align-items-center"><StarOutlined />Style</div>}>
          <MenuItem key="style:color"><BgColorsOutlined />Pick Colors</MenuItem>
          <MenuItem key="style:font"><FontSizeOutlined />Choose Fonts</MenuItem>
        </Menu.SubMenu>

        <Menu.SubMenu className="editorHeaderSubmenu" title={<div className="d-flex align-items-center"><SettingOutlined />Tools</div>}>
          <MenuItem key="meta:seo"><RocketOutlined />SEO</MenuItem>
          <MenuItem key="meta:analytics"><LineChartOutlined />Analytics</MenuItem>
        </Menu.SubMenu>

      </Menu>
    );

    let cascadeOptions = [];
    let cascadeValue = [];
    let selectedPage = null;
    let selectedVariant = null;
    let selectedPageName = "";
    let selectedVariantName = "";
    if (this.props.page.status === "loaded") {
      const { pages } = this.props.page;
      cascadeOptions.push({
        label: 'My Pages',
        value: 'page',
        disabled: true,
      });
      pages.forEach((page, index) => {
        const pageName = page.name === "" ? 'Page #'+(index+1): page.name;
        let childrenVariants = [{
          value: "variant" + index,
          label: 'Select variant to edit',
          disabled: true,
        }];
        page.variants.forEach((variant, index) => {
          const variantName = variant.name === "" ? 'Variant #'+(index+1): variant.name;
          childrenVariants.push({
            value: variant.urlsafe,
            label: variantName,
            disabled: (variant.urlsafe === this.props.variantUrlsafe),
          });
          if (variant.urlsafe === this.props.variantUrlsafe) {
            selectedPage = page;
            selectedVariant = variant;
            selectedPageName = pageName;
            selectedVariantName = variantName;
          }
        });
        cascadeOptions.push({
          value: page.urlsafe,
          label: pageName,
          children: childrenVariants,
        });
      });
      cascadeValue = [selectedPage.urlsafe, selectedVariant.urlsafe];
    }

    return (
      <div className="editor__header pl-3 d-flex align-items-center justify-content-between">

        <div className="flex-grow-1 d-flex align-items-center">
          <Tooltip placement="bottomLeft" title="Go to list of pages">
            <ArrowLeftOutlined className="editor_dashboard_icon mr-2" onClick={this.props.goPagesHome} />
          </Tooltip>
          <div className="d-none d-md-inline-flex text-secondary flex-column">
            <Cascader
              size="large" expandTrigger="click"
              options={cascadeOptions} value={cascadeValue} allowClear={false}
              onChange={(value, selectedOptions) => { this.props.goToVariant(value[1]); }}
            >
              <div className="editor_header_cascader px-2 d-flex align-items-center">
                <div className="d-inline-block">
                  <div className="editor_header_label">{selectedPageName}</div>
                  <div className="editor_header_desc">{selectedVariantName}</div>
                </div>
                <DownOutlined style={{fontSize: 12}} className="ml-2" />
              </div>
            </Cascader>
          </div>
        </div>

        <div className="d-block d-sm-none mr-4">
          <Dropdown overlay={narrowMenu} placement="bottomLeft" trigger={['click']}>
            <div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
              <div className="text-muted">
                Tools
                <DownOutlined className="ml-1" style={{ fontSize: 12 }} />
              </div>
            </div>
          </Dropdown>
        </div>

        <div className="d-none d-sm-block">
          {wideMenu}
        </div>

        { this.renderPublishNode() }

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/EditorHeader.jsx